import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f05c1b20 = () => interopDefault(import('../pages/view/index.vue' /* webpackChunkName: "pages/view/index" */))
const _f3c95db0 = () => interopDefault(import('../pages/view/_slug.vue' /* webpackChunkName: "pages/view/_slug" */))
const _576fe7f9 = () => interopDefault(import('../components/dynamic-pages/school.vue' /* webpackChunkName: "" */))
const _5044cdaa = () => interopDefault(import('../../config/pages/auth/change-password.vue' /* webpackChunkName: "pages/auth/change-password" */))
const _0d69fdd7 = () => interopDefault(import('../../config/pages/auth/confirm-code.vue' /* webpackChunkName: "pages/auth/confirm-code" */))
const _11eacf85 = () => interopDefault(import('../../config/pages/auth/confirm-code-forget-password.vue' /* webpackChunkName: "pages/auth/confirm-code-forget-password" */))
const _1df08ffe = () => interopDefault(import('../../config/pages/auth/confirm-code-password.vue' /* webpackChunkName: "pages/auth/confirm-code-password" */))
const _12daf5bc = () => interopDefault(import('../../config/pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _d4d66b72 = () => interopDefault(import('../../config/pages/auth/logout.vue' /* webpackChunkName: "pages/auth/logout" */))
const _7c824998 = () => interopDefault(import('../../config/pages/auth/password.vue' /* webpackChunkName: "pages/auth/password" */))
const _bef832ba = () => interopDefault(import('../../config/pages/auth/set-password.vue' /* webpackChunkName: "pages/auth/set-password" */))
const _a9477012 = () => interopDefault(import('../../config/pages/auth/login-by-shortcut-link/_id.vue' /* webpackChunkName: "pages/auth/login-by-shortcut-link/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/view",
    component: _f05c1b20,
    name: "view"
  }, {
    path: "/view/:slug",
    component: _f3c95db0,
    name: "view-slug"
  }, {
    path: "/list/:param1?/:param2?/:param3?/:param4?/:param5?/:param6?/:param7?/:param8?",
    component: _576fe7f9,
    name: "school"
  }, {
    path: "/auth/change-password",
    component: _5044cdaa,
    name: "auth-change-password"
  }, {
    path: "/auth/confirm-code",
    component: _0d69fdd7,
    name: "auth-confirm-code"
  }, {
    path: "/auth/confirm-code-forget-password",
    component: _11eacf85,
    name: "auth-confirm-code-forget-password"
  }, {
    path: "/auth/confirm-code-password",
    component: _1df08ffe,
    name: "auth-confirm-code-password"
  }, {
    path: "/auth/login",
    component: _12daf5bc,
    name: "auth-login"
  }, {
    path: "/auth/logout",
    component: _d4d66b72,
    name: "auth-logout"
  }, {
    path: "/auth/password",
    component: _7c824998,
    name: "auth-password"
  }, {
    path: "/auth/set-password",
    component: _bef832ba,
    name: "auth-set-password"
  }, {
    path: "/auth/login-by-shortcut-link/:id?",
    component: _a9477012,
    name: "auth-login-by-shortcut-link-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
